// Сегменты матрицы: свои столбцы из слов и отдельных фраз. Чистые функции без Vue.
// part = { word, phrase }; countByWord[word] — сколько всего фраз у слова в таблице.
import { splitPhraseToWords } from './wordStat';

export function plural(n, forms) {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return forms[2];
  if (b > 1 && b < 5) return forms[1];
  if (b === 1) return forms[0];
  return forms[2];
}

// Слова, у которых в наборе лежат ВСЕ фразы таблицы. Пары считаются уникально.
function wholeWords(parts, countByWord) {
  const by = new Map();
  const seen = new Set();
  for (const p of parts) {
    const k = p.word + '\u0000' + p.phrase;
    if (seen.has(k)) continue;
    seen.add(k);
    by.set(p.word, (by.get(p.word) || 0) + 1);
  }
  return [...by.entries()].filter(([w, n]) => n === (countByWord || {})[w]).map(([w]) => w);
}

// Целое слово пишем словом, неполное — «слово:фраза».
export function segAutoName(parts, countByWord) {
  const whole = new Set(wholeWords(parts, countByWord));
  const out = [...whole];
  const seen = new Set();
  for (const p of parts) {
    if (whole.has(p.word)) continue;
    const k = p.word + '\u0000' + p.phrase;
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(p.word + ':' + p.phrase);
  }
  return out.join(' + ') || 'пустой сегмент';
}

// Шапка стоит вертикально: имя длиннее самого длинного слова матрицы задрало бы строку заголовков.
export function segNameMax(words) {
  return (words || []).reduce((m, r) => Math.max(m, r.word.length), 8);
}

// Короткое имя вместо длинного, шесть ступеней по порядку.
export function segShortName(parts, max, countByWord, totalPhrases) {
  if (!parts.length) return '';
  // уникальные фразы, а не пары: одна фраза бывает под несколькими словами
  if (new Set(parts.map(p => p.phrase)).size >= totalPhrases) return 'таблица';
  const full = segAutoName(parts, countByWord);
  if (full.length <= max) return full;
  const words = [...new Set(parts.map(p => p.word))];
  const tight = words.join('+');
  if (tight.length <= max) return tight;
  const first = words[0], more = words.length - 1;
  if (more > 0) {
    const tail = '+' + more;
    const cand = first + tail;
    if (cand.length <= max) return cand;
    return first.slice(0, Math.max(1, max - tail.length)) + tail;
  }
  // одно слово, но не все его фразы — помечаем цифрой
  const tail2 = ':' + parts.length;
  return (first + tail2).length <= max ? first + tail2
    : first.slice(0, Math.max(1, max - tail2.length)) + tail2;
}

const norm = t => String(t || '').toLowerCase().replace(/ё/g, 'е').trim();
const stem = s => norm(s).replace(/(ический|ическая|ическое|ый|ий|ой|ая|яя|ое|ее|ые|ие|ь)$/, '');
// Беглая гласная: «окон» -> «окн», иначе не находит «окна».
const fleeting = s => s.replace(/[аеиоуыэюя](?=[^аеиоуыэюя]$)/, '');

// Поиск по связке «слово + фраза»: порядок слов запроса не важен, каждый терм должен найтись
// по началу токена, по основе (от 3 символов) или внутри (терм от 3 символов).
export function segMask(query, text) {
  const q = norm(query);
  if (!q) return false;
  const tok = splitPhraseToWords(norm(text));
  return q.split(/[\s,]+/).filter(Boolean).every(t => {
    const stems = [stem(t), fleeting(t)].filter(s => s.length >= 3);
    return tok.some(w => w.startsWith(t) || stems.some(s => w.startsWith(s)) || (t.length >= 3 && w.includes(t)));
  });
}

// Клик по слову: есть части этого слова — убрать все, иначе добавить все его фразы.
export function togglePhrasesOfWord(parts, word, phrases) {
  if (parts.some(p => p.word === word)) return parts.filter(p => p.word !== word);
  const out = parts.slice();
  for (const phrase of new Set(phrases)) out.push({ word, phrase });
  return out;
}

const key = token => 'ins-segments:' + token;

export function loadSegments(token) {
  try {
    const v = JSON.parse(localStorage.getItem(key(token)));
    return Array.isArray(v) ? v : [];
  } catch (e) { return []; }
}

export function saveSegments(token, list) {
  try { localStorage.setItem(key(token), JSON.stringify(list)); } catch (e) { /* приватный режим: тихо */ }
}

export function newSegId() {
  return Math.random().toString(36).slice(2, 7);
}
